/** @param {import("../viewer-deps.js").ViewerDeps} deps */
export function createEditor(deps) {
  function parseEditorJson(text) {
    const trimmed = text.trim();
    if (!trimmed) {
      return { ok: false, error: new SyntaxError("Пустой JSON") };
    }
    try {
      return { ok: true, value: JSON.parse(text) };
    } catch (strictError) {
      const relaxed = text.replace(/,\s*([}\]])/g, "$1");
      if (relaxed !== text) {
        try {
          return { ok: true, value: JSON.parse(relaxed), normalized: true };
        } catch {
          /* fall through */
        }
      }
      return { ok: false, error: strictError };
    }
  }

  function syncEditorToDoc(options = {}) {
    if (deps.getEditorProgrammatic() || !deps.getDoc()) return;
    const showErrors = options.showErrors === true;
    const parsedResult = parseEditorJson(deps.source.value);
    if (!parsedResult.ok) {
      if (showErrors) {
        deps.errorBox.hidden = false;
        deps.errorBox.textContent = `JSON: ${parsedResult.error.message}`;
      } else {
        deps.errorBox.hidden = true;
      }
      deps.updateNodeSaveButton();
      return;
    }
    const parsed = parsedResult.value;
    if (!deps.setNodeByKey(deps.getSelectedKey(), deps.getDoc(), parsed)) {
      if (showErrors) {
        deps.errorBox.hidden = false;
        deps.errorBox.textContent = `Не удалось записать узел: ${deps.getSelectedKey()}`;
      }
      deps.updateNodeSaveButton();
      return;
    }
    deps.errorBox.hidden = true;
    try {
      deps.paint({ refreshEditor: false });
    } catch (error) {
      deps.errorBox.hidden = false;
      deps.errorBox.textContent = `Preview: ${error.message}`;
      deps.updateNodeSaveButton();
      return;
    }
    const shouldFormat = options.formatEditor === true
      || (options.formatEditor !== false && !deps.editorEditingCurrentSelection());
    if (shouldFormat) {
      deps.formatEditorJson(parsed);
    }
    deps.updateNodeSaveButton();
    deps.refreshEditorContractCheck();
  }

  return { syncEditorToDoc, parseEditorJson };
}
